import React, { useEffect, useState } from "react";
import PackageApi from "../../api/PackageApi";

function EditDetails({ data, fetchList, clearSelection }) {
  const [packageName, setPackageName] = useState("");
  const [modules, setModules] = useState([]);

  useEffect(() => {
    if (data) {
      setPackageName(data.packageName);
      setModules(data.modules || []);
    }
  }, [data]);

  const addRow = () => {
    setModules([...modules, { moduleName: "", description: "" }]);
  };

  const deleteRow = (index) => {
    const updated = modules.filter((_, i) => i !== index);
    setModules(updated);
  };

  const handleChange = (index, field, value) => {
    const updated = [...modules];
    updated[index][field] = value;
    setModules(updated);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    await PackageApi.update({
      id: data._id,
      packageName,
      modules,
    });

    const modalEl = document.getElementById("edit-package-modal");
    const modalInstance = window.bootstrap.Modal.getInstance(modalEl);
    modalInstance.hide();

    if (fetchList) fetchList();
    if (clearSelection) clearSelection();
  };

  return (
    <div className="modal-dialog modal-lg">
      <div className="modal-content">
        <div className="modal-header">
          <h4>Edit Package</h4>
          <button className="btn-close" data-bs-dismiss="modal" onClick={clearSelection}/>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body">

            <input
              type="text"
              className="form-control mb-3"
              value={packageName}
              onChange={(e) => setPackageName(e.target.value)}
            />

            <div className="d-flex justify-content-between mb-2">
              <h5>Modules</h5>
              <button type="button" className="btn btn-primary btn-sm" onClick={addRow}>
                + Add Row
              </button>
            </div>

            {modules.map((row, index) => (
              <div className="row mb-2" key={index}>
                <div className="col-md-4">
                  <input
                    className="form-control"
                    value={row.moduleName}
                    onChange={(e) =>
                      handleChange(index, "moduleName", e.target.value)
                    }
                  />
                </div>

                <div className="col-md-6">
                  <textarea
                    className="form-control"
                    value={row.description}
                    onChange={(e) =>
                      handleChange(index, "description", e.target.value)
                    }
                  />
                </div>

                <div className="col-md-2">
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={() => deleteRow(index)}
                  >
                    ❌
                  </button>
                </div>
              </div>
            ))}

          </div>

          <div className="modal-footer">
            <button className="btn btn-secondary" data-bs-dismiss="modal">
              Close
            </button>
            <button className="btn btn-primary">Update</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditDetails;